import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { client } from 'projects/angular-clarity/src/app/stores/client';
import { CustomNamedLocation } from 'projects/angular-clarity/src/app/stores/client/graph/named-locations/reducer';

export interface NamedLocationDialogData {
    tenantId: string;
    selectedItems: string[];
}

@Component({
    selector: 'app-named-locations-dialog',
    templateUrl: './named-locations-dialog.component.html',
    styleUrls: ['./named-locations-dialog.component.scss'],
})
export class NamedLocationsDialogComponent implements OnInit, OnDestroy {
    tenantId: string;

    locations: (CustomNamedLocation & { checked: boolean })[];
    activeStage: 'select' | 'ip' | 'country' = 'select';
    sub: Subscription;
    itemToBeUpdated: CustomNamedLocation;
    constructor(
        @Inject(MAT_DIALOG_DATA) private data: NamedLocationDialogData,
        private dialogRef: MatDialogRef<NamedLocationsDialogComponent>,
        private store: Store<any>,
    ) {
        if (data) {
            this.tenantId = data.tenantId;
        }
    }
    ngOnDestroy(): void {
        this.sub?.unsubscribe();
    }
    ngOnInit(): void {
        this.sub = this.store.pipe(select(client(this.tenantId).graph.namedLocations.all)).subscribe((res) => {
            this.locations = res.map((res) => ({
                ...res,
                checked: this.data.selectedItems.some((item) => item === res.id),
            }));
        });
    }

    save() {
        this.dialogRef.close(this.locations.filter((res) => res.checked).map((res) => res.id));
    }

    openUpdateLocation(item: CustomNamedLocation) {
        if (item['@odata.type'] === '#microsoft.graph.ipNamedLocation') {
            this.activeStage = 'ip';
            this.itemToBeUpdated = item;
        } else {
            this.activeStage = 'country';
            this.itemToBeUpdated = item;
        }
    }
}
